import React, { useState, useEffect } from "react";
import { Flex } from "rebass/styled-components";
import ReactPlaceholder from "react-placeholder";
import { TextRow } from "react-placeholder/lib/placeholders";

import {
  Modal,
  FloatingContainer,
} from "../../../../../../Components/Wrappers";

import { Large3, Title2 } from "../../../../../../Components/Text";
import ReportDropdown from "../Report";

import theme from "../../../../../../../theme/themeThree";

// todo
import { Avatar } from "../../../../../../../components/atoms/avatar";
import {
  AvatarBorder,
  getAvatarBorderLevel,
} from "../../../../../../Utilities/User";

import { FollowButton } from "../../../../../../../components/atoms/form/button/follow";
import { FollowStats } from "../../../../../../../components/molecules/followStats";
import { ProcessingNotification } from "../../../../../../Components/ProcessingPill";

import { Report } from "../../../../../../../components/molecules/reportModal";
import { FollowersModal } from "../../../../../../../components/organisms/modalContents/followers";
import { useIsDesktopApp } from "../../../../../../Hooks/useIsDesktopApp";
import { Button } from "MVVM/Components/Button";
import { analytics } from "MVVM/Analytics";

function Owner({
  allstarUser,
  followUnfollow,
  followers,
  following,
  displayName,
  avatarImage,
  user,
  classification = "transparent",
  ...props
}) {
  const isDesktopApp = useIsDesktopApp();
  const [ready, setReady] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [followModalState, setFollowModalOpen] = useState(false); //this is for the followers/following modal, the prop above is for the CTA
  const [count, setCount] = useState({ followers: "", following: "" });
  const avatarBorderLevel = getAvatarBorderLevel(user);

  const isPaid = ["PRO", "CREATOR_PLAT"].includes(
    allstarUser?.user?.userGroup?.type,
  );
  const optionsProps = {
    setModalOpen: setModalOpen,
    setFollowModalOpen: setFollowModalOpen,
  };

  useEffect(() => {
    // console.count("Owner - setCount");
    if (following && followers) {
      setReady(true);
      setCount({ followers: followers.length, following: following.length });
    }
  }, [followers, following]);

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="flex-start"
      {...props}
    >
      {/* this logic here needs to be handled inside one component so that we can render different variations of avatar borders and avatars just by passing userRank */}
      <ReactPlaceholder
        customPlaceholder={ownerPlaceholder}
        ready={!props.loading}
      >
        <Flex
          justifyContent="flex-start"
          alignItems="center"
          flexDirection="row"
        >
          {avatarBorderLevel ? (
            <AvatarBorder type={avatarBorderLevel} size="large">
              <Avatar
                loading={props.loading}
                size="large"
                image={avatarImage}
              />
            </AvatarBorder>
          ) : (
            <Avatar size="large" image={avatarImage}></Avatar>
          )}
          <Flex
            justifyContent="center"
            alignItems="flex-start"
            flexDirection="column"
            ml={5}
          >
            <Large3 name="profile-username">{displayName}</Large3>
            <Title2 mt={2}>{props.rank}</Title2>

            <FollowStats
              loading={!ready}
              followers={count.followers}
              following={count.following}
              setFollowModalOpen={setFollowModalOpen}
            />
          </Flex>
        </Flex>

        <Flex
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          minHeight="60px"
        >
          {isDesktopApp.isDesktop ? (
            <Flex py={18} />
          ) : !props.isOwnProfile ? (
            <Flex flexDirection="row" alignItems="center" py={7}>
              {allstarUser.loggedIn && (
                <FollowButton
                  flex={true}
                  size="small"
                  mr={4}
                  userId={props.userId}
                  displayName={displayName}
                  avatar={avatarImage}
                  allstarUser={allstarUser}
                  followUnfollow={followUnfollow}
                />
              )}
              {(user.steamId || user.riotId) && (
                <Button
                  classification="rounded"
                  size="small"
                  flex
                  mr={allstarUser.loggedIn ? 4 : 0}
                  onClick={() =>
                    analytics.track("Button - Click", {
                      location: "profile",
                      locationIdentifier: "matchHistoryOwner",
                      source: "website",
                    })
                  }
                  to={`/match-history?playerSearchIdentifier=${
                    user.steamId || user.riotId
                  }`}
                >
                  Match History
                </Button>
              )}
              {allstarUser.loggedIn && (
                <ReportDropdown
                  size="social"
                  classification={classification}
                  optionsProps={optionsProps}
                />
              )}
            </Flex>
          ) : (
            <Flex pb={18} pt={isPaid ? 30 : 18}>
              <ProcessingNotification
                my={7}
                user={user?.userId}
                clickable
                skipProcessingQuery={!props.isOwnProfile}
              />
            </Flex>
          )}
        </Flex>
      </ReactPlaceholder>
      <Modal isModalOpen={isModalOpen} setModalOpen={setModalOpen}>
        <FloatingContainer>
          <Report
            setModalOpen={setModalOpen}
            reportedUserId={user.userId}
            isProfile={true}
          />
        </FloatingContainer>
      </Modal>
      <>
        {ready ? (
          <>
            <Modal
              isModalOpen={followModalState}
              setModalOpen={setFollowModalOpen}
            >
              <FollowersModal
                allstarUser={allstarUser}
                followUnfollow={followUnfollow}
                user={user.userId}
                followerData={{
                  followers: followers,
                  following: following,
                }}
                view={followModalState}
                setModalOpen={setFollowModalOpen}
                count={count}
              />
            </Modal>
          </>
        ) : (
          <></>
        )}
      </>
    </Flex>
  );
}

export { Owner };

const ownerPlaceholder = (
  <>
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        marginTop: `${theme.space[5]}px`,
        height: theme.text.large3.fontSize,
        width: "100%",
        maxWidth: "330px",
      }}
    />
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        height: theme.text.title2.fontSize,
        width: "80%",
        maxWidth: "150px",
        marginTop: `${theme.space[2]}px`,
      }}
    />
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        height: theme.text.headline.fontSize,
        width: "80%",
        maxWidth: "200px",
        marginTop: `${theme.space[2]}px`,
      }}
    />
  </>
);
